module.exports = " <div von-app> <navbar></navbar> <router-view transition=view class=view></router-view> </div> <modal v-ref:modal></modal> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/index.vue
// module id = 230
// module chunks = 0